import fr from "../../lang/fr.json";

export const t = key => {
	const args = key.split(":");
	return fr[args[0]][args[1]];
};
